import type { ReactNode } from 'react';

interface SectionHeadingProps {
  id?: string;
  title: ReactNode;
  description?: ReactNode;
  description2?: ReactNode;
  tone?: 'default' | 'inverse';
  className?: string;
  /** Overrides the title's font-size/line-height classes (default `text-h2`).
   *  Lets a section swap in a fluid mobile→desktop clamp() without touching
   *  every other consumer of this shared heading. */
  titleClassName?: string;
  /** Same as `titleClassName`, for the description paragraphs (default `text-base`). */
  descriptionClassName?: string;
}

export function SectionHeading({
  id,
  title,
  description,
  description2,
  tone = 'default',
  className = '',
  titleClassName = 'text-h2',
  descriptionClassName = 'text-base',
}: SectionHeadingProps) {
  return (
    <div className={`flex flex-col gap-2 ${className}`}>
      <h2
        id={id}
        className={`${titleClassName} font-semibold tracking-tight ${
          tone === 'inverse' ? 'text-white' : 'text-ink'
        }`}
      >
        {title}
      </h2>
      <div className="flex flex-col">
        {description ? (
          <p
            className={`${descriptionClassName} ${tone === 'inverse' ? 'text-white/70' : 'text-text-secondary'}`}
          >
            {description}
          </p>
        ) : null}
        {description2 ? (
          <p
            className={`${descriptionClassName} ${tone === 'inverse' ? 'text-white/70' : 'text-text-secondary'}`}
          >
            {description2}
          </p>
        ) : null}
      </div>
    </div>
  );
}
